import React from 'react';
import MasterCrud from './MasterCrud';

export default function Companies() {
  return (
    <MasterCrud
      title="Sub Contractors"
      endpoint="/api/master/companies"
      columns={[
        { key: 'name', label: 'Name' },
        { key: 'ownerName', label: 'Owner' },
        { key: 'city', label: 'City' },
        { key: 'state', label: 'State' },
        { key: 'phoneNumber', label: 'Phone' },
        { key: 'email', label: 'Email' },
        { key: 'status', label: 'Status' },
        { key: 'updatedAt', label: 'Last updated' },
      ]}
      formFields={[
        { key: 'name', label: 'Name', required: true },
        { key: 'ownerName', label: 'Owner Name', helperText: 'Sub-contractor owner/contact (shown on IVY invoice)' },
        { key: 'addressLine1', label: 'Address Line 1' },
        { key: 'addressLine2', label: 'Address Line 2' },
        { key: 'city', label: 'City' },
        { key: 'state', label: 'State' },
        { key: 'postalCode', label: 'Postal Code' },
        { key: 'country', label: 'Country' },
        { key: 'phoneNumber', label: 'Phone Number' },
        { key: 'email', label: 'Email', type: 'email' },
        { key: 'website', label: 'Website' },
        { key: 'status', label: 'Status', helperText: 'active or inactive' },
      ]}
    />
  );
}
